const Client = [
  {
    id: "1",
    image: "",
    name: "Eugene Freeman",
    designation: "Tincidunt",
    description:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, omnis.",
  },
  {
    id: "2",
    image: "",
    name: "Kelly Coleman",
    designation: "Nulla nec",
    description:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, omnis.",
  },
  {
    id: "2",
    image: "",
    name: "Kelly Coleman",
    designation: "Nulla nec",
    description:
      " Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, omnis.",
  },
];

export default Client;
